<!--基本信息录入-->
<template>
   <div class="contentRight">
      <div class="inputList">
         <el-form ref="inputForm" :model="form" label-width="180px" label-suffix=":">
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="企业名称" prop="company_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.company_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="企业资质" prop="enp_qualification"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.enp_qualification"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="通讯地址" prop="postal_address"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.postal_address"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="邮编" prop="post_code"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input type="text" v-model="form.post_code" placeholder="请输入6位数字" show-word-limit maxlength="6" />
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="法人代表" prop="legal_person"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.legal_person"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="法人联系电话" prop="legal_phone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.legal_phone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="联系人" prop="contact_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="联系人职务" prop="post"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.post"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="联系电话" prop="contact_phone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_phone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="推荐单位" prop="recommend_unit"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.recommend_unit" filterable remote reserve-keyword
                             placeholder="请选择推荐单位"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.recomList" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
         </el-form>
      </div>
      <div class="uploadBtn" v-if="isEdit" style="margin-top: 5px; margin-bottom: 5px;">
         <el-button type="primary" @click="_saveData">保存</el-button>
      </div>
   </div>
</template>

<script>
   import {
      getApplyBasicInfo,
      postApplyBasicInfo
   } from "@/api/modules/advCompanyApply";
   import {getCompanyInfoByLoginUser,getRecomCompany} from '@/api/modules/project'
   import labelInput from '@/components/table/labelInput.vue'
   import labelSelect from "@/components/table/labelSelect";
   import ruiTool from "@/utils/ruiTool";
   import {vaildte} from "@/utils/validate";

   export default {
      data() {
         return {
            form: {
               opMode: '',
               loginName: '',
               //项目序号
               project_application_id: '',
               //项目编号
               project_code: '',
               //登录公司编稿
               company_code: '',
               //企业名称
               company_name: '',
               //企业资质
               enp_qualification: '',
               //通讯地址
               postal_address: '',
               //邮编
               post_code: '',
               //法人
               legal_person: '',
               //法人联系电话
               legal_phone: '',
               //联系人
               contact_name: '',
               //联系人职务
               post: '',
               //联系人电话
               contact_phone: '',
               //推荐单位
               recommend_unit: ''
            },
            ddl: {
               /*推荐单位*/
               recomList: []
            }
         }
      },
      computed: {
         isEdit() {
            return this.form.opMode == 'edit';
         }
      },
      components: {
         labelInput,
         labelSelect
      },
      mounted() {
         //获取保存的传入参数
         this.form.project_application_id = localStorage.getItem("prjApplyCode")
         this.form.project_code = localStorage.getItem("prjCode");
         this.form.opMode = localStorage.getItem("opMode");

         //获取登录企业编号
         this.form.loginName = localStorage.getItem('loginName');
         this.form.company_code = localStorage.getItem('company_code');

         if (ruiTool.isNull(this.form.project_application_id)) {
            //新增模式
            this._getCompanyInfo();
            this._getRecomCompany();
         } else {
            //修改模式，展示原数据
            getApplyBasicInfo({
               data: {prjApplyID: this.form.project_application_id},
               success: (res) => {
                  //数据赋值
                  Object.keys(res.data.item).forEach((key) => {
                     this.form[key] = res.data.item[key]
                  })
                  this._getRecomCompany();
               }
            })
         }
      },
      methods: {
         /*提交基本数据*/
         _saveData() {
            this.$refs['inputForm'].validate((valid) => {
               if (valid) {
                  postApplyBasicInfo({
                     data: this.form,
                     success: (res) => {
                        Object.keys(res.data.item).forEach((key) => {
                           this.form[key] = res.data.item[key];
                        })
                        //将当前申报项目编号保存到本地存储
                        localStorage.setItem("prjApplyCode", this.form.project_application_id);
                        this.$message.success("保存成功");
                     }
                  })
               } else {
                  this.$message.error("存在未填写项");
               }
            })
         },
         /*根据登录账号获取企业默认信息*/
         async _getCompanyInfo() {
            let param = {loginUser: localStorage.getItem('loginName')};
            await getCompanyInfoByLoginUser({
               data: param,
               success: (res) => {
                  console.log(res.data);
                  //默认数据赋值
                  this.form.company_name = res.data.item.name;
                  console.log(this.form.company_name);
                  this.form.postal_address = res.data.item.address;
                  this.form.legal_person = res.data.item.legal_person;
                  this.form.legal_phone = res.data.item.cellphone;
               }
            })
         },
         /*获取推荐单位*/
         async _getRecomCompany() {
            let param = {
               project_code: this.form.project_code,
               projectType: localStorage.getItem('projectType')
            }
            console.log('获取推荐单位', param);
            await getRecomCompany({
               data: param,
               success: (res) => {
                  this.ddl.recomList = res.data.ddl;
               }
            })
         },
         /*接收输入*/
         labelInput(e, name) {
            this.form[name] = e
         },
      }
   }
</script>

<style scoped>
   .contentRight {
      width: 100%;
   }

   /* 上传样式 */
   .inputList {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
   }
</style>